// Vendors
import $ from 'jquery';
import List from 'list.js';

$(document).ready(() => {
  // fuzzy search
  const options = { valueNames: ['coop-name'], item: selectedToTop() };
  const userList = new List('coops', options);

  // move selected to top
  function selectedToTop() {
    const selected = document.querySelector('#coops .selected');
    const list = document.querySelector('#coops .list');

    if (selected) {
      const selectedContainer = selected.parentNode.parentNode.parentNode;
      list.prepend(selectedContainer);
    }
  }

  const { endpoint, nonce } = window.uConfig;
  let updateTheseFields = {};

  // even listeners
  $(document).on('click', '.coop-select__btn:not(.selected)', (event) =>
    setCoop(event)
  );

  function setCoop(event) {
    event.preventDefault();

    const $coopID = $(event.currentTarget).attr('data-id');
    const $coopName = $(event.currentTarget)
      .parent()
      .siblings()
      .children('.coop__select__name')
      .text();
    const $form = $('#coops');

    $form.addClass('form--loading');

    setTimeout(() => {
      makeAjaxCall($coopName, $coopID);
    }, Math.random() * 750);
  }

  function makeAjaxCall(myCoop, coopID) {
    $.ajax({
      url: endpoint,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'wl_coop_select',
        coop_id: coopID,
        nonce
      },
      success: ({ success, data: { error, updated, message } }) => {
        location.href = '/';
      }
    });
  }
});
